<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Fees Notice Details" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
				</div>
			</div>
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
        <table class="table mb-0">
            <thead class="bg-primary text-white">
                <tr>
                    <th class="datatable-th">Product Name</th>
                    <!-- <th class="datatable-th">Quantity</th>
                    <th class="datatable-th">Unit Price</th> -->
                    <th class="datatable-th">Charges</th>
                    <th class="datatable-th">Deduction</th>
                    <th class="datatable-th">Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rowData" :key="index">
                <td>{{ row.product_id.name }}</td>
                <!-- <td>{{ row.qty }}</td>
                <td>{{ formattedIDR(row.price) }}</td> -->
                <td>{{ row.debit === 0 ? '' : formattedIDR(row.debit ?? row.price) }}</td>
                <td>
                    <span v-if="row.credit === 0"></span>
                    <span v-else style="color:red;">
                        ({{ formattedIDR(row.credit ?? 0) }})
                    </span>
                </td>
                <td>{{ row.balance === 0 ? '' : formattedIDR(row.balance ?? row.price) }}</td>
                </tr>
            </tbody>
        </table>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";

export default {
	extends: CoreLibrary,
	inject: ["eventHub"],
	name: "FeesNoticeDetailsTable",
	props: {
		invoiceRequestId: {
			type: Number,  
		},
	},
	mixins: [],
    data() {
        return {
            rowData: [], 
        };
    },
    mounted() {
        this.loadFeeNoticeDetails();
    },
	methods: {
        async loadFeeNoticeDetails() {
            try {
                const res = await axios.get(
                `/transaction/invoice-v2/${this.invoiceRequestId}/fee-notice-details`
                );

                // normalisasi response langsung array
                this.rowData = Array.isArray(res.data) ? res.data : res.data.data || [];

            } catch (err) {
                console.error("Gagal load fee notice details:", err);
                this.rowData = [];
            }
        },
        
        formattedIDR(value) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0
            }).format(value);
        }
	},
};
</script>
